import { HeroImage } from "../../../assets/contact";

export default function SectionOne()
{
    return(
        <section  className="py-5 bg-cover bg-center h-80 md:h-96 flex justify-center items-center"
        style={{ backgroundImage: `url(${HeroImage})` }}>
            <div className="flex flex-col items-center space-y-3 text-white w-[60%]">
                <p className="text-xl md:text-2xl xl:text-3xl font-medium">We Would love to hear from you !</p>
                <p className="text-base md:text-lg xl:text-xl font-medium text-center">Reach out for product inquiries, repair services, or any support you need.
                    Whether it’s a purchase or repair, we’re just a message away!</p>
            </div>
        </section>
    );
}